module.exports = __webpack_public_path__ + "img/noapte-de-decembrie-madrigal.08cf377f.jpg";